import "./LRadioPlayerMain.css";
import LSlidingPlayer from "./LSlidingPlayer";


export default function MRadioPlayerMain() {
  return (
    <div className="l-radio-player-header">
      <LSlidingPlayer />
    </div>
  );
}
